import { render, staticRenderFns } from "./AdminPanel.vue?vue&type=template&id=6f153d9a"
import script from "./AdminPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminPanel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports